import { Box, Typography } from "@mui/joy";
import { ClassicyControlGroup } from "../../components/control-group/ClassicyControlGroup";
import "../styles/QuestionnaireSteps.css";

interface ActivitySelectionStepProps {
  selectedActivities: string[];
  onToggle: (activity: string) => void;
}

const ACTIVITIES = [
  { name: "Games", displayName: "Spiele" },
  { name: "Office work", displayName: "Büroarbeit" },
  { name: "Graphics/Design", displayName: "Grafik / Design" },
  { name: "Web browsing", displayName: "Im Internet surfen" },
  { name: "Music/iTunes", displayName: "Musik / iTunes" },
  { name: "Video editing", displayName: "Videobearbeitung" },
  { name: "Email", displayName: "E-Mail" },
  { name: "Learning/Education", displayName: "Lernen / Bildung" },
  { name: "Programming", displayName: "Programmieren" },
];

function ActivitySelectionStep({
  selectedActivities,
  onToggle,
}: ActivitySelectionStepProps) {
  return (
    <Box className="questionnaire-step">
      <Typography level="h2" sx={{ mb: 3, textAlign: "center" }}>
        Wofür hast du ihn benutzt?
      </Typography>
      <Typography level="h3" sx={{ mb: 3, textAlign: "center", opacity: 0.8 }}>
        Wähle alle zutreffenden aus
      </Typography>

      <ClassicyControlGroup
        label="Aktivitäten (mehrere auswählbar)"
        columns={false}
      >
        <Box className="option-grid">
          {ACTIVITIES.map((activity) => (
            <button
              key={activity.name}
              className={`option-button ${selectedActivities.includes(activity.name) ? "selected" : ""}`}
              onClick={() => onToggle(activity.name)}
            >
              {activity.displayName}
            </button>
          ))}
        </Box>
      </ClassicyControlGroup>
    </Box>
  );
}

export default ActivitySelectionStep;
